'hasOwn' in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));
